var exports = {
  "Qs": "AddGuildModal.module__content___elNoQX",
  "lF": "AddGuildModal.module__footerReveal___elNoQX",
  "BT": "AddGuildModal.module__landingContainer___elNoQX",
  "Xg": "AddGuildModal.module__actionButtonsGroup___elNoQX",
  "uu": "AddGuildModal.module__actionButtons___elNoQX",
  "hP": "AddGuildModal.module__actionButton___elNoQX",
  "gE": "AddGuildModal.module__actionIcon___elNoQX",
  "ZJ": "AddGuildModal.module__actionLabel___elNoQX",
  "KJ": "AddGuildModal.module__formContainer___elNoQX",
  "r2": "AddGuildModal.module__iconSection___elNoQX",
  "ff": "AddGuildModal.module__iconSectionInner___elNoQX",
  "go": "AddGuildModal.module__iconLabel___elNoQX",
  "O2": "AddGuildModal.module__iconPreview___elNoQX",
  "Dp": "AddGuildModal.module__iconImage___elNoQX",
  "Pz": "AddGuildModal.module__iconPlaceholder___elNoQX",
  "Ne": "AddGuildModal.module__iconInitials___elNoQX",
  "D_": "AddGuildModal.module__iconActions___elNoQX",
  "Nu": "AddGuildModal.module__iconButtons___elNoQX",
  "m5": "AddGuildModal.module__iconError___elNoQX",
  "I4": "AddGuildModal.module__guidelines___elNoQX",
  "YC": "AddGuildModal.module__guidelinesLink___elNoQX",
  "$J": "AddGuildModal.module__templatePreview___elNoQX",
  "pT": "AddGuildModal.module__templateInfo___elNoQX",
  "x7": "AddGuildModal.module__templateLabel___elNoQX",
  "G": "AddGuildModal.module__templateName___elNoQX",
  "qt": "AddGuildModal.module__templateStats___elNoQX",
  "W4": "AddGuildModal.module__openApiUrlButton___elNoQX",
  "OJ": "AddGuildModal.module__verificationNotice___elNoQX",
};

module.exports = exports;
